import React from 'react';
import { Box, Typography } from '@mui/material';
import { FinancialConditionSection } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/shared/FinancialConditionSection.tsx';
import { STATE_AID_RECEIVED_ROWS } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/stateAidReceived/constants.ts';
import { StateAidMatrix } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/stateAidReceived/StateAidMatrix.tsx';
import {
  getStateAidQuarterLabel,
  type TStateAidQuarterWindowItem,
} from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/stateAidReceived/quarterUtils.ts';
import { documentGenerationFormStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/styles.ts';

interface IStateAidReceivedHistorySectionProps {
  programName: string;
  disabled: boolean;
  quarters: TStateAidQuarterWindowItem[];
}

export const StateAidReceivedHistorySection: React.FC<IStateAidReceivedHistorySectionProps> = ({
  programName,
  disabled,
  quarters,
}) => (
  <FinancialConditionSection
    title="1. Інформація про суми отриманої державної допомоги"
    description={`У межах програми «${programName}».`}
  >
    {Array.from(new Set(quarters.map(({ year }) => year))).map((year) => (
      <Box key={year} sx={documentGenerationFormStyles.section}>
        <Typography component="h3" sx={documentGenerationFormStyles.sectionTitle}>
          {year}
        </Typography>
        {quarters.map(
          (quarter, index) =>
            quarter.year === year && (
              <StateAidMatrix
                key={`${quarter.year}-${quarter.quarter}`}
                title={getStateAidQuarterLabel(quarter)}
                prefix={`receivedAidQuarters.${index}`}
                nestedPrefix
                rows={STATE_AID_RECEIVED_ROWS}
                disabled={disabled}
              />
            )
        )}
      </Box>
    ))}
  </FinancialConditionSection>
);
